/**
 * Snooze preset computation. Pure functions; tested by manual time-travel in dev tools.
 */

export type SnoozePreset = {
  key: string;
  label: string;
  iso: string;
  shortcut?: string;
};

function atHour(d: Date, hour: number): Date {
  const out = new Date(d);
  out.setHours(hour, 0, 0, 0);
  return out;
}

function nextWeekday(d: Date, target: number): Date {
  const out = new Date(d);
  const diff = (target + 7 - out.getDay()) % 7 || 7;
  out.setDate(out.getDate() + diff);
  return atHour(out, 9);
}

export function snoozePresets(now: Date = new Date()): SnoozePreset[] {
  // 1 hour
  const oneHour = new Date(now.getTime() + 60 * 60 * 1000);
  // Later today @ 5pm — only show if it's currently before 4pm
  const today5 = atHour(now, 17);
  const showLaterToday = now.getHours() < 16;
  // Tomorrow 9am
  const tomorrow9 = atHour(new Date(now.getTime() + 24 * 60 * 60 * 1000), 9);
  // Next Monday 9am
  const nextMonday9 = nextWeekday(now, 1);
  // Next week (in 7 days @ 9am)
  const nextWeek9 = atHour(new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000), 9);

  const presets: SnoozePreset[] = [
    { key: '1h', label: 'In 1 hour', iso: oneHour.toISOString(), shortcut: '1' },
  ];
  if (showLaterToday) {
    presets.push({ key: 'today_5pm', label: 'Later today (5pm)', iso: today5.toISOString(), shortcut: '2' });
  }
  presets.push(
    { key: 'tomorrow', label: 'Tomorrow 9am', iso: tomorrow9.toISOString(), shortcut: '3' },
    { key: 'next_mon', label: 'Next Monday 9am', iso: nextMonday9.toISOString(), shortcut: '4' },
    { key: 'next_week', label: 'Next week', iso: nextWeek9.toISOString(), shortcut: '5' },
  );
  return presets;
}
